class ProductMaterialsCare extends HTMLElement {
  constructor() {
    super();

    this.videoContainerId = '#mc-video-player';
    this.previousWidth = window.innerWidth; // 判定window width变化才触发resize
    this.firstInited = false; // 是否已初始化
    this.videoInited = false; // 是否已初始化
    this.videoPlayer = null; // 视频播放实例
    this.vidstackPlayer = null; // Vidstack播放器类
    this.vidstackPlayerLayout = null; // Vidstack布局类
    this.resourcesLoaded = false; // 资源是否已加载
    this.mcVideoList = [];  // 视频列表
    this.mcVideoListLen = 0;  // 视频列表长度
    this.currentVideoIndex = -1; // 当前播放的视频index

    // 获取DOM元素
    this.elements = {
      dialogContainer: this.querySelector('.mc-popup-dialog'),  // 弹窗容器
      dialogCloseButton: this.querySelector('.mc-popup-dialog-close'),  // 关闭按钮
      mediaElements: this.querySelector(this.videoContainerId), // 弹窗视频容器
      switchDots: document.querySelectorAll('.video-swith-item'),  // 移动端底部的navigate dots
    };
  }

  connectedCallback() {
    // 元素被添加到DOM时调用
    // 监听section进入视口初始化
    window.addEventListener('DOMContentLoaded', () => {
      this.observeElement(this, this.handleResize.bind(this));
    });
    // 添加 resize 事件监听器
    this.resizeListener = this.debounce(this.handleResize.bind(this), 200);
    window.addEventListener('resize', this.resizeListener);
  }

  disconnectedCallback() {
    // 元素从DOM中移除时调用
    this.destroySlick(pmcImageWrapper);
    // 清理引用
    this.vidstackPlayer = null;
    this.vidstackPlayerLayout = null;
    window.removeEventListener('resize', this.resizeListener);
  }

  // 创建一个 IntersectionObserver 实例
  observeElement(element, callback) {
    // 如果已经在视口内,立即执行回调
    if (this.isElementInViewport(element)) {
      callback();
      return;
    }
    const observer = new IntersectionObserver((entries, observerInstance) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          callback();
          // 只执行一次，停止观察
          observerInstance.unobserve(entry.target);
        }
      });
    }, {
      // 视口外 1/2 高度以内触发
      root: null,
      threshold: 0.5
    });
    observer.observe(element);
  }
  // 判断元素是否在视口内
  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= -el.offsetHeight / 2 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + el.offsetHeight / 2
    );
  }

  // 加载Vidstack资源
  async loadVidstackResources() {
    if (this.resourcesLoaded) return true;

    try {
      // 获取配置
      const configElement = document.querySelector('.vidstack-config');
      if (!configElement) throw new Error('未找到Vidstack配置元素');

      const config = JSON.parse(configElement.textContent.trim());
      const themeConfig = config.theme?.vidstack;
      if (!themeConfig) throw new Error('Vidstack配置无效');

      // 加载CSS
      const loadCSS = (url) => {
        if (!url) return;
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        document.head.appendChild(link);
      };

      loadCSS(themeConfig.css?.player);
      loadCSS(themeConfig.css?.theme);

      // 预加载JS
      const jsUrl = themeConfig.js?.[0];
      if (jsUrl) {
        const preloadJS = document.createElement('link');
        preloadJS.rel = 'modulepreload';
        preloadJS.href = jsUrl;
        document.head.appendChild(preloadJS);
      }

      if (!jsUrl) throw new Error('配置中未找到JS URL');

      // 动态导入JS
      const { VidstackPlayer, VidstackPlayerLayout } = await import(jsUrl);
      this.vidstackPlayer = VidstackPlayer;
      this.vidstackPlayerLayout = VidstackPlayerLayout;

      this.resourcesLoaded = true;
      return true;
    } catch (error) {
      return false;
    }
  }

  // 初始化 Slick
  initSlick(pmcImageWrapper = $(this.querySelector(`.materials-imagelist-wrapper`))) {
    pmcImageWrapper.slick({
      infinite: true,
      draggable: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="product-materials-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="product-materials-prev">Product Materials Image Prev</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="product-materials-next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="product-materials-next">Product Materials Image Next</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>',
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 590,
          settings: {
            slidesToShow: 1,
            autoplay: false,
            autoplaySpeed: 3000,
          }
        }
      ]
    });
  }

  // 初始化移动端 toggle show more效果
  initToggleShowMore(selector = this.querySelector(`.materials-imagelist-wrapper`)) {
    let pmcImageWrapper = $(selector);
    if (pmcImageWrapper.length > 0) {
      const imageItems = this.querySelectorAll(`.materials-imagelist .image-item`);
      if (imageItems.length < 5) {
        $(this.querySelector(`.toggle-show-more`)).remove();
        return;
      }

      let listHeight = parseInt(selector.scrollHeight);
      let foldHeight = parseInt(2 * ($(imageItems[0]).innerHeight() + 4));
      if (listHeight > foldHeight) {
        pmcImageWrapper.css(`height`, `${foldHeight}px`);
        $(document).off(`click`, `.toggle-show-more`).on(`click`, `.toggle-show-more`, (e) => {
          e.preventDefault();
          e.stopPropagation();
          let tempEl = $(e.target).siblings(`.materials-imagelist`).find(`.materials-imagelist-wrapper`);
          let currHeight = parseInt(tempEl.height());
          if (currHeight != foldHeight) {
            tempEl.css(`height`, `${foldHeight}px`);
            $(e.target).text(`Show More`);
          } else {
            tempEl.css(`height`, `${listHeight}px`);
            $(e.target).text(`Show Less`);
          }
        });
      } else {
        $(this.querySelector(`.toggle-show-more`)).remove();
      }
    }
  }

  // Destroy Slick
  destroySlick(pmcImageWrapper = $(this.querySelector(`.materials-imagelist-wrapper`))) {
    if (pmcImageWrapper.hasClass('slick-initialized')) {
      pmcImageWrapper.slick('unslick');
    }
  }

  // Resize Event
  handleResize() {
    let selector = this.querySelector(`.materials-imagelist-wrapper`);
    let pmcImageWrapper = $(selector);
    let currentWidth = window.innerWidth;
    if(!this.firstInited) {
      // ADA：如果图片的alt属性重复，给图片alt加上后续View index
      const images = Array.from(selector?.querySelectorAll('img') || []);
      // 统一清理 alt（防止 View 叠加）
      const normalize = (str) =>
        (str || '')
          .replace(/,?\s*View\s*\d+$/, '') // 去掉已有 View
          .trim();
      // 第一步：统计每个 alt 出现次数
      const altCountMap = new Map();
      images.forEach((img) => {
        const alt = normalize(img.getAttribute('alt'));
        if (!alt) return;
        altCountMap.set(alt, (altCountMap.get(alt) || 0) + 1);
      });
      // 第二步：只对重复的 alt 追加 View index
      const altIndexMap = new Map();
      images.forEach((img) => {
        const rawAlt = normalize(img.getAttribute('alt'));
        if (!rawAlt) return;
        const total = altCountMap.get(rawAlt);
        // 只处理重复的
        if (total > 1) {
          const index = (altIndexMap.get(rawAlt) || 0) + 1;
          altIndexMap.set(rawAlt, index);
          const newAlt = `${rawAlt}, View ${index}`;
          img.setAttribute('alt', newAlt);
          img.setAttribute('title', newAlt);
        } else {
          // 单个的不动（可选：清理旧 title）
          img.setAttribute('alt', rawAlt);
          img.setAttribute('title', rawAlt);
        }
      });

      if(currentWidth >= 591) {
        pmcImageWrapper.css(`height`, `auto`);
        this.initSlick(pmcImageWrapper);
      } else {
        this.initToggleShowMore(selector);
      }
      this.firstInited = true;
    } else if (this.firstInited && currentWidth !== this.previousWidth) {
      this.previousWidth = currentWidth;
      if(currentWidth >= 591) {
        pmcImageWrapper.css(`height`, `auto`);
        pmcImageWrapper.hasClass('.slick-initialized') ? pmcImageWrapper.slick('refresh') : this.initSlick(pmcImageWrapper);
      } else {
        pmcImageWrapper.hasClass('.slick-initialized') && pmcImageWrapper.slick('unslick');
        this.initToggleShowMore(selector);
      }
    }

    // 进入视口后加载资源
    if (!this.resourcesLoaded) {
      this.loadVidstackResources().then(success => {
        if (success) {this.initVideo();}
      });
    }

    this.setfocusableAccessibility();
    this.escCloseModal();
  }

  // 初始化视频相关弹窗
  initVideo() {
    this.mcVideoList = mcVideoList; // 获取video list (const)
    this.mcVideoListLen = this.mcVideoList.length;  // 获取video list length

    // poster button event
    $(document).on("click", '.pp-btn', (e) => {
      let self = e.target.closest('button');
      let videoIndex = self.getAttribute("data-index");
      this.currentVideoIndex = this.mcVideoList.findIndex(item => item.id === videoIndex);  // 确定videolist数组的index
      let video = this.mcVideoList[this.currentVideoIndex];
      if (!this.videoPlayer) {
        this.vidstackPlayer?.create({
          target: this.videoContainerId,
          title: video.title,
          src: video.src,
          poster: video.poster || null,
          viewType: 'video',
          streamType: 'on-demand',
          logLevel: 'warn',
          muted: true,
          crossOrigin: true,
          playsInline: true,
          autoplay: true,
          controls: true,
          loop: true,
        });
        this.videoPlayer = this.elements.mediaElements?.querySelector('media-player');
      } else {
        this.videoPlayer.src = video.src;
        this.videoPlayer.title = video.title;
        this.videoPlayer.poster = video.poster;
        this.videoPlayer.play();
      }
      this.setNavigateActive(this.currentVideoIndex);
      this.dialogShow();
    });

    // 点击切换按钮，切换视频（上一个/下一个）
    $(document).on("click", ".video-control-btn", (e) => {
      e.preventDefault();
      e.stopPropagation();
      let btnTarget = e.target.closest('button');
      if (btnTarget.classList.contains("prev-btn")) {
        this.currentVideoIndex = (this.currentVideoIndex - 1 + this.mcVideoListLen) % this.mcVideoListLen;
      } else if (btnTarget.classList.contains("next-btn")) {
        this.currentVideoIndex = (this.currentVideoIndex + 1) % this.mcVideoListLen;
      }
      this.switchVideo(this.videoPlayer, this.mcVideoList, this.currentVideoIndex);
    });

    // 移动端点击Navigate Dots切换视频
    $(document).on("click", ".video-swith-item", (e) => {
      e.preventDefault();
      e.stopPropagation();
      let clickedIndex = e.target.closest('.video-swith-item')?.getAttribute("data-index");
      this.currentVideoIndex = clickedIndex;
      this.switchVideo(this.videoPlayer, this.mcVideoList, clickedIndex);
    });

    this.elements.dialogCloseButton?.addEventListener('click', () => this.dialogHide());
    this.elements.dialogCloseButton?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.stopPropagation();
        e.preventDefault();
        this.dialogHide();
      }
    });
    this.elements.dialogContainer?.addEventListener('click', (e) => e.target === this.elements.dialogContainer && this.dialogHide());
  }

  // Switch Video
  switchVideo(player = this.videoPlayer, videoArr, currIndex) {
    let nextVideo = videoArr[currIndex];
    player.src = nextVideo.src;
    player.title = nextVideo.title;
    player.poster = nextVideo.poster;
    player.play();
    this.setNavigateActive(currIndex);
  }

  // Set Switch Navigate Dot Active
  setNavigateActive(activeIndex) {
    this.elements.switchDots?.forEach(dot => {dot?.classList.remove("active");});
    this.querySelector(`.video-swith-item[data-index="${activeIndex}"]`).classList.add("active");
  }

  // 显示弹窗
  dialogShow() {
    this.elements.dialogContainer?.setAttribute('open', '');
  }

  // 隐藏弹窗
  dialogHide() {
    this.elements.dialogContainer?.removeAttribute('open');
    this.elements.mediaElements?.querySelector('media-player').pause();
  }

  // ADA
  setfocusableAccessibility(){
    let lastFocusableElement = this.querySelector('.last-focusable-element');
    lastFocusableElement?.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        e.preventDefault(); 
        e.stopPropagation();
        let firstFocusableElement = this.querySelector('.first-focusable-element');
        if (firstFocusableElement) {
          firstFocusableElement.focus();
        }
      }
    });
  }
  // 关闭加购后插件弹窗
  escCloseModal(){
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.elements.dialogContainer?.hasAttribute("open")) { // 检查是否按下 Esc 键
        e.preventDefault();
        e.stopPropagation();
        this.dialogHide();
      }
    });
  }

  debounce(func, wait) {
    let timeout;
    return function(...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define('product-materials-care', ProductMaterialsCare);
